import { useState, useEffect, useRef } from 'react'

export type ActiveToolState = {
  id: string
  name: string
  status: 'pending' | 'running' | 'complete' | 'error'
  startTime: number
  endTime?: number
  input?: Record<string, unknown>
  output?: unknown
  error?: string
}

export function useChatPanelState() {
  const [isChatVisible, setIsChatVisible] = useState(false)
  const [activeTools, setActiveTools] = useState<ActiveToolState[]>([])
  const [currentReasoning, setCurrentReasoning] = useState<string>('')
  const currentReasoningRef = useRef<string>('')

  useEffect(() => {
    currentReasoningRef.current = currentReasoning
  }, [currentReasoning])

  return {
    isChatVisible,
    setIsChatVisible,
    activeTools,
    setActiveTools,
    currentReasoning,
    setCurrentReasoning,
    currentReasoningRef
  }
}
